@let _auth = authenticator.auth$ | async;
@let _accName = accName$ | async;

<button [title]="'navigation.menu' | translate" [appDropdown]="dropdownContent" [appDropdownOptions]="{positionX: 'right'}">
  @if (_auth && _accName) {
    <div class="user-logo">{{ usernameFirstCharacter | async }}</div>
  }

  @if (!_auth) {
    <app-svg-icon [name]="'user'" />
  }
</button>

<ng-template #dropdownContent>
  <div class="menu">
    @if (_auth && _accName) {
      <a class="menu-item account" [href]="idSystemUrl" target="_blank">
        <div class="user-logo">{{ usernameFirstCharacter | async }}</div>
        {{_accName}}
        <app-svg-icon [name]="'settings'" />
      </a>
      <app-separator [type]="'horizontal'" [style]="'solid'" />
    }


    <a class="menu-item" (click)="getSettingsClickHandler()" tabindex="0">
      <app-svg-icon [name]="'settings'" />
      {{ 'settings.title' | translate }}
    </a>


    <a class="menu-item" (click)="supportClick()" tabindex="0">
      <app-svg-icon [name]="'chat'" />
      {{ 'support.title' | translate }}
    </a>

    @if (_auth === true) {
      <a class="menu-item" (click)="logoutClick()" tabindex="0">
        <app-svg-icon [name]="'logout'" />
        {{ 'logout.title' | translate }}
      </a>
    }
    @else if (_auth === false) {
      <a class="menu-item" (click)="loginClick()" tabindex="0">
        <app-svg-icon [name]="'login'" />
        {{ 'login.title' | translate }}
      </a>
    }
  </div>
</ng-template>
